<template>
  <answer-template
    :answer-type="'regex'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'change-rule'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>
    </template>
    <template v-slot:content>
      <div class="custom-form">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Name</span>
          </div>
          <input type="text" class="form-control" v-model="inputData.name" @input="editValue">
        </div>
      </div>
      <div class="custom-form">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Regex</span>
          </div>
          <input type="text" class="form-control" v-model="inputData.regex" @input="editValue">
        </div>
      </div>

      <div class="custom-form">
        <div class="flag-label"><label for="flag">Flag</label></div>
<!--        <div class="form-check form-check-inline">-->
<!--          <input class="form-check-input mt-0" type="checkbox" v-model="inputData.flag.global" @change="editValue">-->
<!--          <label class="form-check-label" for="Global">Global</label>-->
<!--        </div>-->
<!--        <div class="form-check form-check-inline">-->
<!--          <input class="form-check-input mt-0" type="checkbox" v-model="inputData.flag.multiline" @change="editValue">-->
<!--          <label class="form-check-label" for="Multiline">Multiline</label>-->
<!--        </div>-->
        <div class="form-check form-check-inline">
          <input class="form-check-input mt-0" type="checkbox" v-model="inputData.flag.insensitive" @change="editValue">
          <label class="form-check-label" for="Insensitive">Insensitive</label>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from '../Answers/AnswerTemplate.vue';

export default {
  name: 'regexList',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: '',
          ruleId: '',
        };
      },
    },
    isFirst: {
      type: Boolean,
      default: true,
    },
    isLast: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
    },
  },
  mounted() {
  },
  data() {
    return {
      originalRegex: {},
      originalFlag: {},
      isEdit: false,
      isChangeName: false,
      isSave: false,
    };
  },
  methods: {
    editValue() {
      this.$emit('editRegex', this.inputData);
      this.$emit('dirty');
    },
  },
};
</script>
<style lang="scss" scoped>
  .custom-form {
    margin-top: .625rem !important;
    padding-left: 1.25rem!important;
    padding-right: 1.25rem!important;
  }
  .flag-label {
    font-weight: 600;
  }

</style>
